// extracted by mini-css-extract-plugin
module.exports = {"main":"manual-lookup-module--main--1lWkn","tabs":"manual-lookup-module--tabs--3BWJO"};